export default __webpack_public_path__ + "static/media/afl1.957f36b7.svg";